import { DynamicTableHelper, ArrayHelper } from "@workspace/common";

const JOB_APP_MANDATORY_OPTIONS = [
  {
    sortValue: "jobTitle",
    label: "Job Title",
    value: "jobTitle",
    sort: true,
    expand: true,
  },
];

const JOB_APP_INITIAL_OPTIONS = [
  {
    sortValue: "jobId",
    label: "Pulse Job ID",
    value: "jobId",
    sort: true,
    expand: true,
  },
  {
    sortValue: "accountName",
    label: "Account Name",
    value: "accountName",
    sort: true,
    expand: true,
  },
  {
    sortValue: "jobType",
    label: "Job Type",
    value: "jobType",
    sort: true,
  },
  {
    sortValue: "status",
    label: "Status",
    value: "status",
    sort: true,
  },
  {
    sortValue: "first_name",
    label: "First Name",
    value: "firstName",
    sort: true,
    expand: true,
  },
  {
    sortValue: "last_name",
    label: "Last Name",
    value: "lastName",
    sort: true,
    expand: true,
  },
  {
    sortValue: "resumeName",
    label: "CV",
    value: "resumeName",
    sort: true,
    expand: true,
  },
  {
    sortValue: "date_applied",
    label: "Applied On",
    value: "dateApplied",
    sort: true,
  },
  {
    sortValue: "email",
    label: "Email",
    value: "email",
    sort: true,
  },
  {
    sortValue: "mobile",
    label: "Mobile",
    value: "mobile",
    sort: true,
  },
  {
    sortValue: "current_location",
    label: "Current Location",
    value: "currentLocation",
    sort: true,
  },
  {
    sortValue: "total_experience",
    label: "Total Experience",
    value: "totalExperience",
    sort: true,
  },
  {
    sortValue: "relevant_experience",
    label: "Relevant Experience",
    value: "relevantExperience",
    sort: true,
  },
  {
    sortValue: "current_salary",
    label: "Current Salary",
    value: "currentSalary",
    sort: true,
  },
  {
    sortValue: "expecting_salary",
    label: "Expected Salary",
    value: "expectingSalary",
    sort: true,
  },
  {
    sortValue: "notice_period",
    label: "Notice Period",
    value: "noticePeriod",
    sort: true,
  },
  {
    sortValue: "reason_for_change",
    label: "Reason for Change",
    value: "reasonForChange",
    sort: true,
  },
  {
    sortValue: "referrer_name",
    label: "Referrer Name",
    value: "referrerName",
    sort: true,
  },
  {
    sortValue: "candidate_source",
    label: "Candidate Source",
    value: "candidateSource",
    sort: true,
  },
  {
    sortValue: "remark",
    label: "Remark",
    value: "remark",
    sort: true,
  },
  {
    sortValue: "secondary_owner",
    label: "Secondary Owner",
    value: "secondaryOwner",
    sort: true,
  },
];

const JOB_APP_LABELS = {
  "": "All Job Applications",
  new: "New Job Applications",
  approved: "Approved Job Applications",
  rejected: "Rejected Job Applications",
};

const JOB_APP_MAIN_FIELDS = [];

const jobAppForm = {
  formSchema: [
    { name: "jobId" },
    { name: "firstName" },
    { name: "lastName" },
    { name: "email" },
    { name: "mobile" },
    { name: "gender" },
    { name: "currentLocation" },
    { name: "totalExperience" },
    { name: "relevantExperience" },
    { name: "currentSalary" },
    { name: "expectingSalary" },
    { name: "noticePeriod" },
    { name: "reasonForChange" },
    { name: "referrerName" },
    { name: "candidateSource" },
    { name: "resume" },
    { name: "resumeName" },
    { name: "remark" },
    { name: "jobTitle" },
    { name: "jobType" },
    { name: "secondaryOwner" },
    { name: "accountName" },
    { name: "status" },
    { name: "dateApplied" },
  ],
};

const generateJobAppFields = (jobAppForm) => {
  const fields = [...JOB_APP_MAIN_FIELDS];

  function formatString(input) {
    // Remove asterisk if present
    input = input.replace("*", "");

    // Convert camelCase to space-separated words with proper capitalization
    let result = input
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
      .replace(/([A-Z])/g, " $1") // Add space before each capital letter
      .trim(); // Remove leading/trailing spaces

    // Capitalize the first letter of each word
    result = result
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return result;
  }

  const buildOptionsArray = (formSchema, groupedLabel = "") => {
    const options = [];
    formSchema?.forEach((field) => {
      if (field?.name && field?.name !== "") {
        const data = {};
        data.label = formatString(field.name);
        data.value = field?.name;
        data.sortValue = field?.name;
        data.sort = true;
        if (groupedLabel) {
          data.groupedLabel = groupedLabel;
        }
        options.push(data);
      }
    });
    return options;
  };

  if (jobAppForm) {
    const jobAppOptions = buildOptionsArray(jobAppForm?.formSchema, "Job");

    fields.push(...jobAppOptions);
  }

  // Remove duplicate value in the object of array. Keep the first
  const fieldsNew = fields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  ArrayHelper.sortArrayObjIcase(fieldsNew, "label");

  return fieldsNew;
};

export {
  JOB_APP_INITIAL_OPTIONS,
  JOB_APP_MANDATORY_OPTIONS,
  JOB_APP_LABELS,
  jobAppForm,
  generateJobAppFields,
};
